/** Which dropped files are Carveco/Vectric designs. Kept free of imports so the
 * main thread can ask the question without pulling in the CFB parser. */
const CAM_EXTENSIONS = /\.(crv|crv3d|v3m|art)$/i;

export function isCamFile(name: string): boolean {
  return CAM_EXTENSIONS.test(name.trim());
}
